/**
 * A stable per-browser anonymous id, used to meter the one free no-wallet
 * gilding. It's only a UX limiter (the server also enforces an IP backstop +
 * global ceiling), so a cleared/forged id can't farm beyond those caps.
 */
const KEY = 'gilding_anon_id';

export function anonId(): string {
  if (typeof window === 'undefined') return 'ssr';
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `a_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Private mode / storage blocked — a per-session id is fine; the server caps cover abuse.
    return `a_${Math.random().toString(36).slice(2)}`;
  }
}
